import { AddSportButtons, Matches, NflMatches, NbaMatches } from "../Components";
import React, { useEffect,useState } from "react";
import { MlbSchedule } from "../Components/mlb.js";
import Logo from "../Components/Logo.jsx";
import { supabase } from "../supabaseClient.jsx";
import { checkAndUpdateTokens } from "../Data/betdata/CheckAndUpdateTokens.jsx";
import { useTheme } from "../Components/theme/ThemeContext.jsx";
import SeasonalStart from "../Components/theme/SeasonalStart.jsx";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Home() {
  const [selectedMatchType, setSelectMatchesUI] = useState("Hockey");
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [showseasonTheme, setShowSeasonTheme] = useState(true);
  const { theme } = useTheme();
    useEffect(() => {
    const timer = setTimeout(() => setShowSeasonTheme(false), 4000); // 4 seconds
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchLoggedInUser = async () => {
      const { data: sessionData, error: sessionError } =
        await supabase.auth.getSession();
  
      if (sessionError) {
        console.error("Error fetching session:", sessionError);
        return;
      }
  
      if (sessionData && sessionData.session) {
        const user = sessionData.session.user;
        const { data: userData, error: userError } = await supabase
          .from("users")
          .select("*")
          .eq("public_user_id", user.id)
          .single();
  
        if (userError) {
          console.error("Error fetching user data:", userError);
        } else {
          const updatedUser = await checkAndUpdateTokens(userData);
          setLoggedInUser(updatedUser);
        }
      }
    };
  
    fetchLoggedInUser();
  }, []);
  
  const selectMatchesUI = () => {
    if (selectedMatchType === "Hockey") {
      return <Matches />;
    }
    if (selectedMatchType === "Football") {
      return <NflMatches />;
    }
    if (selectedMatchType === "Baseball") {
      return <MlbSchedule />;
    } else {
      if (selectedMatchType === "Basketball") {
        return <NbaMatches />;
      }
      return (
        <div className="text-center text-white">Feature not yet Added</div>
      );
    }
  };
  return (
<>
  <div className={`home-screen theme-${theme}`}>
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
    >
      <Logo />
      <AddSportButtons setSelectMatchesType={setSelectMatchesUI} />
      {selectMatchesUI()}
    </motion.div>

    <motion.footer
      className="home-screen__footer"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay: 0.06, ease: "easeOut" }}
    >
      <div className="home-screen__footer-top">
        <Link to="/mini-games" className="home-screen__arcade-link fb-btn fb-btn--ghost">
          Play Mini Games
        </Link>
      </div>
      <p className="home-screen__footer-copy">&copy; 2026 Friendly Bets. All rights reserved.</p>
      <Link to="/contact" className="home-screen__footer-contact">
        Contact
      </Link>
    </motion.footer>
  </div>

  {showseasonTheme && <SeasonalStart onFinish={() => setShowSeasonTheme(false)} />}
</>
  );
}

export default Home;
